import { useState } from 'react';
import CloseIcon from '../../../assets/icons/close.svg?react';
import Pagination from '../../../components/Pagination/Pagination';


const AlertSetUpTargetListModal = ({ onClose, target, onGoToEdit }) => {
  // 페이징 만들기
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 5;
  const totalPages = Math.ceil(target.NotificationTargets.length / pageSize);
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleGoToEdit = () => {
    // 수정 모달 열기
    onClose();
    onGoToEdit(target);
  };
  
  return (
    <div className="modal-background">
      <div className="modal-container alert-setup-target-edit-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>알림 대상 목록</h3>
          <button className="close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="modal-content flex flex-col gap-10">
          <table className="primary-table w-full">
            <thead>
              <tr>
                <th width="100px">대상타입</th>
                <th>대상값</th>
              </tr>
            </thead>
            {target.NotificationTargets.length === 0 ? (
              <tbody>
                <tr>
                  <td colSpan="2" className="text-center text-b2-400 text-gray-600">알림 대상이 없습니다.</td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                {target.NotificationTargets.map((notiTarget) => (
                  <tr key={notiTarget.NotificationTargetSysId}>
                    <td>{notiTarget.TargetType}</td>
                    <td>{notiTarget.TargetValue}</td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
          {target.NotificationTargets.length > 0 && (
            <div className="flex justify-center mb-10">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
                size="small"
              />
            </div>
          )}
        </div>
        <div className="modal-footer">
          <button className="btn big-btn btn-primary" onClick={handleGoToEdit}>
            수정
          </button>
        </div>
      </div>
    </div>
  )
}

export default AlertSetUpTargetListModal